<template>
  <div
    class="mx-4 text-xs text-left grid grid-cols-5 border-b dark:bg-dark-800 dark:text-dark-text dark:border-dark-300 bg-white border-gray-300 text-gray-600"
    style="padding-left: 44px"
  >
    <div class="pl-4 pr-2 py-2">
      {{ $t('message.judgeId') }}
    </div>
    <div class="py-2 px-2">
      {{ $t('message.status') }}
    </div>
    <div class="py-2 px-2">
      {{ $t('message.language') }}
    </div>
    <div class="py-2 px-2 col-span-2">
      {{ $t('message.dateTime') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {}
  }
})
</script>

<style lang="postcss" scoped></style>
